module.exports = __webpack_public_path__ + "img/2.6f629f0d.png";